import {Highlighter, observer, pluralize, React, useAsObservableSource, useLocalStore} from '@api'
import {MenuItem} from '@blueprintjs/core'
import {GroupByDropdownStore, useGroupByDropdownStore, useVipLocalStore} from '@modules'
import * as css from './GroupByMenuItem.css'
import {GroupByGrouping, StoresInstance} from '@stores'
import {VipLocalStore} from '@modules'
import {action, computed, toJS} from 'mobx'

class GroupByMenuItemStore extends VipLocalStore{
  constructor(stores: StoresInstance,public props: { group: GroupByGrouping, store: GroupByDropdownStore }) {
    super(stores)
  }

  get group() { return this.props.group}

  get store() { return this.props.store }

  @computed get active() {
    const {groupBy, group: {indexInHierarchy, level, isCatalogItemsGrouping, fieldDefinition}, store} = this,
      {isProductView} = groupBy

    return groupBy.hierarchyGroups.filter(_.identity).some(hg => (hg.vlpType ? hg.mySubtitleFieldsNonHierarchy : hg.subtitleFields).some(f => f.field === fieldDefinition?.field))
           || store?.props?.group === this.group
           || (isCatalogItemsGrouping && (isProductView || store?.props?.group == this.group ))
  }

  @computed get groupSubtitleIndex() {
    const {subtitleGrouping} = this
    return subtitleGrouping ? (subtitleGrouping.vlpType ? subtitleGrouping.mySubtitleFieldsNonHierarchy : subtitleGrouping.mySubtitleFields)?.findIndex(f => f.field === this.group.fieldName) : -1
  }

  @computed get subtitleGrouping() {
    const {group, groupBy} = this

    return groupBy.hierarchyGroups.find(hg => hg?.mySubtitleFields?.some(f => f.field === group.fieldName))
  }

  @computed get icon() {
    const {active, groupSubtitleIndex, groupBy, catalog, group: {groupName, indexInHierarchy}} = this,
      {isProductView} = groupBy

    if (groupSubtitleIndex != -1) {
      return <div className={css.subtitleIcon}>S<sub>{groupSubtitleIndex + 1}</sub></div>
    }

    if (indexInHierarchy != -1) {
      return <div className={css.titleIcon} data-level={indexInHierarchy}>H<sub>{indexInHierarchy + 1}</sub></div>
    }

    return active || (groupName === catalog.index && isProductView) ? 'tick' : 'blank'
  }

  @action onClickItem = () => {
    const {groupSubtitleIndex, subtitleGrouping, groupBy, store: {source, isSubtitleSubmenu, grouping}, group: {fieldDefinition}} = this, {menuStore: {subtitleButtonActive}} = groupBy
    if (isSubtitleSubmenu) {
      (subtitleGrouping ?? grouping).toggleSubtitleField(fieldDefinition?.field)
    }
    else if (subtitleButtonActive || groupSubtitleIndex != -1 || (subtitleButtonActive && groupBy.isGroupedView && groupBy.hierarchy.every(f => f !== fieldDefinition?.field))) {
      (subtitleGrouping ?? grouping).toggleSubtitleField(fieldDefinition?.field)
    } else {
      this.group.toggleInHierarchy(grouping?.level, source)
    }
  }
}
const GroupByMenuItemContext = React.createContext<GroupByMenuItemStore>(null)

const useNewGroupByMenuItemStore = (group: GroupByGrouping) => {
  const store = useGroupByDropdownStore(),
    obsProps = useAsObservableSource({group, store})
  return useVipLocalStore((ws) => new GroupByMenuItemStore(ws, obsProps))
}

export const GroupByMenuItem = observer<{ label?: string, grouping: GroupByGrouping, level?: number , fixedmaxwidth?:string}>(({grouping, label: propsLabel, ...props}) => {
  const store = useNewGroupByMenuItemStore(grouping)

  if (!store?.group || !store?.groupBy?.menuStore) return null

  const {
      group: {groupName, fieldDefinition, itemCount: count, titleAndCount: {label}, hierarchyTypeGroup}, active, icon, onClickItem, groupBy, catalog
    } = store


  const  {menuStore: {searchResults, isSearching, searchWords, subtitleButtonActive}} = groupBy

  return (
    <GroupByMenuItemContext.Provider value={store}>
    <MenuItem
      key={groupName}
      className={css.groupByMenuItem}
      disabled={subtitleButtonActive && hierarchyTypeGroup}
      //title={name}
      data-id={`groupBy-${groupName ?? catalog.index}`}
      data-active={active}
      data-es-index={fieldDefinition?.esIndex}
      data-workspace={fieldDefinition?.workspace}
      data-field={fieldDefinition?.field}
      data-section={fieldDefinition?.section}
      data-search-result={isSearching && searchResults.has(groupName)}
      text={<span data-value={groupName} className={css.titleText}>
        <Highlighter textToHighlight={propsLabel ?? label} searchWords={searchWords} className={css.title}/></span>}
      labelElement={
        <div className={css.labelElement}>
          {/*{associatedLibrary ? <span className={css.associatedLibrary}>{associatedLibrary?.title}</span> : <span className={css.associatedWorkspace}>{pluralize((associatedWorkspace ?? catalog.workspaceConfig).title, 1)}</span>}*/}
          <span className={css.count} data-testid={`groupBy-spec-${groupName}-count`}>({count == null ? '...' : count.value ?? count})</span>
        </div>}
      icon={icon}
      shouldDismissPopover={store.store.source === 'contextMenu' && store.group != null}
      onClick={onClickItem}
      data-fixedmaxwidth={props.fixedmaxwidth}
      {...props}
    />
    </GroupByMenuItemContext.Provider>)
});



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Menus/Toolbar/GroupChips/GroupByMenuItem.tsx